// Added by Sejune Oh on 2019-09-04
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { reaction, makeAutoObservable } from 'mobx'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import Logger from '@/helper/Logger'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import Rootstore from '../../index'
import {
    reqGetServerEventStream,
    StreamOnProcess,
    StreamOnCompleteFuncProps,
    StreamOnErrorFuncProps,
} from './ConnectionStore.service'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export default class ConnectionStore {
    root?: Rootstore

    _updateInterval: any
    signOut?: Function
    destroyConnection?: Function
    controller = new AbortController() // Logout시 fetch abort

    constructor(rootStore: Rootstore) {
        this.root = rootStore
        makeAutoObservable(this)
        reaction(
            () => this.root!.userAuth!.isSignedUp,
            (isUserSignedUp: any) => {
                if (typeof isUserSignedUp === undefined) return

                if (!isUserSignedUp) {
                    if (this.signOut) this.signOut()
                }
            }
        )
    }

    bindServerEventWithListener = (
        onProessResponse: StreamOnProcess,
        onConnected: Function,
        onComplete: StreamOnCompleteFuncProps,
        onError: StreamOnErrorFuncProps
    ) => {
        reqGetServerEventStream({
            onProessResponse,
            onComplete,
            onConnected,
            onError,
            bindSignOutFunction: this._bindUserSignOutFunction,
            bindDestroyFunction: this._bindDestroyStreamFunction,
            signal: this.controller.signal
        })
    }

    _bindUserSignOutFunction = (reader: ReadableStreamDefaultReader<Uint8Array>) => {
        this.signOut = async () => {
            try {
                await reader.cancel()
                /** abort fetch when User Sign out */
                if (!this.controller.signal.aborted) this.controller.abort()

                if (await reader.closed) Logger.devLog('[ConnectionStore] Stream closed successfully.')
            } catch (err) {
                Logger.errLog('[ConnectionStore] Fail to close stream.')
            }
        }
    }

    _bindDestroyStreamFunction = (reader: ReadableStreamDefaultReader<Uint8Array>) => {
        this.destroyConnection = async () => {
            try {
                await reader.cancel()

                if (await reader.closed) Logger.devLog('[ConnectionStore] Stream closed successfully. (Manually)')
            } catch (err) {
                Logger.errLog('[ConnectionStore] Fail to close stream. (Manually)')
            }
        }
    }
}
